import groq from 'groq';
import { PageType, defaultLanguage } from '@stereoagency/constants';
import { $globalSanityClient } from '@/sanity';

const metadataQuery = [
  groq`coalesce(
    *[
      _type == "translation.metadata"
      && "page" in schemaTypes
      && (
        ($slug == "/" && length(translations[value->pageType == "${PageType.HOMEPAGE}"]) > 0)
        || (translations[_key == $language][0].value->slug.current == $slug)
        || (translations[_key == $fallback][0].value->slug.current == $slug)
      )
    ][0]{
      "translations": translations[].value->{
        _id,
        slug,
        language
      }
    },
    *[_type == "page" && language == $fallback && slug.current == $slug][0]{
      "translations": [{
        "_id": @._id,
        "slug": @.slug,
        "language": @.language
      }]
    }
  )`,
  {} as {
    translations: ({
      _id: string;
      slug: { current: string };
      language: string;
    } | null)[];
  } | null
] as const;

export default async function fetchTranslationMetadataForSlugAndLang(
  lang: string,
  slug: string
) {
  const result = await $globalSanityClient.fetch<(typeof metadataQuery)[1]>(
    metadataQuery[0],
    {
      language: lang,
      fallback: defaultLanguage.id,
      slug
    }
  );

  return result;
}
